import { useCallback } from 'react'
import { useDispatch } from 'react-redux'

import * as HookAction from '../actions/customerAction'
import {customerAnnouncementAction} from "../actions/customerAction";

export const ActionInit = () => {
    const dispatch = useDispatch()
    return useCallback(
        () => dispatch(HookAction.customerInit()),
        [dispatch]
    )
}

export const ActionGetListCustomer = () => {
    const dispatch = useDispatch()
    return useCallback(
        (filters) => dispatch(HookAction.customerListAction(filters)),
        [dispatch]
    )
}

export const ActionGetItem = () => {
    const dispatch = useDispatch()
    return useCallback(
        (params) => dispatch(HookAction.customerGetItemAction(params)),
        [dispatch]
    )
}

export const ActionMasterData = () => {
    const dispatch = useDispatch()
    return useCallback(
        (params) => dispatch(HookAction.customerMasterDataAction(params)),
        [dispatch]
    )
}

export const ActionCreateCustomer = () => {
    const dispatch = useDispatch()
    return useCallback(
        (params) => dispatch(HookAction.customerCreateAction(params)),
        [dispatch]
    )
}
export const ActionUpdateCustomer = () => {
    const dispatch = useDispatch()
    return useCallback(
        (params) => dispatch(HookAction.customerUpdateAction(params)),
        [dispatch]
    )
}

export const ActionCustomerCreditList = () => {
    const dispatch = useDispatch()
    return useCallback(
        (params) => dispatch(HookAction.customerCreditListAction(params)),
        [dispatch]
    )
}

export const ActionCustomerCreditAdd = () => {
    const dispatch = useDispatch()
    return useCallback(
        (params) => dispatch(HookAction.customerCreditAddAction(params)),
        [dispatch]
    )
}

export const ActionCustomerAnnouncementList = () => {
    const dispatch = useDispatch()
    return useCallback(
        (params) => dispatch(HookAction.customerAnnouncementListAction(params)),
        [dispatch]
    )
}

export const ActionCustomerAnnouncementAction = () => {
    const dispatch = useDispatch()
    return useCallback(
        (params) => dispatch(HookAction.customerAnnouncementAction(params)),
        [dispatch]
    )
}
